import { Platform, Text, type TextProps } from 'react-native';
import { webPrivacyProps } from '../lib/privacy';

type MoneyProps = TextProps & {
  className?: string;
  /** DM Mono only ships 400 (regular) and 500 (medium). Default: 400. */
  weight?: 400 | 500;
};

export function Money({ weight = 400, className = '', style, ...props }: MoneyProps) {
  const { dataSet, ...textProps } = props as TextProps & {
    dataSet?: Record<string, string | number | boolean>;
  };
  const fontFamily = weight === 500 ? 'DMMono_500Medium' : 'DMMono_400Regular';
  return (
    <Text
      className={className}
      style={[
        { fontFamily },
        Platform.OS === 'ios' ? { fontVariant: ['tabular-nums'] } : null,
        style,
      ]}
      {...webPrivacyProps('financial', dataSet)}
      {...textProps}
    />
  );
}
